module.exports = __webpack_public_path__ + "static/img/pucko_otvoreno_uciliste_zagreb.c3dfcf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/pucko_otvoreno_uciliste_zagreb.png
// module id = GPe6
// module chunks = 0